import { Component, OnInit } from '@angular/core';
import { hideByHeight } from '../../animations/openFullscreen.animation';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { AppState } from '../../../app.reducer';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { BreadcrumbsService, MenuItem } from '../../../services/breadcrumbs.service';
import { organizationInfoSelector } from '../../../store/organization.selectors';
import { successAuthBackPage } from 'app/store/user.actions';
import { take } from 'rxjs';
import { authPath, confirmPath, profilePath } from 'app/constants/pages-constants';

@UntilDestroy()
@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  animations: [hideByHeight]
})
export class HeaderComponent implements OnInit {
  public showAuthButtons: boolean = true; // можно ли вообще авторизовываться

  logoImgSrc: string = './assets/img/logo_get_it.png';
  showCloseButton = true; // показывать ли кнопку закрытия виджета

  backRoute: ActivatedRoute | null = null;
  rootRoute: ActivatedRoute | null = null;

  private readonly imgReg = /(\.svg)|(\.jpg)|(\.jpeg)|(\.png)$/i;

  constructor(
    public router: Router,
    public route: ActivatedRoute,
    public window: Window,
    public store: Store<AppState>,
    public breadcrumbsService: BreadcrumbsService
  ) {
  }

  closeWidget(): void {
    this.window.parent.postMessage('close-widget', '*');
  }

  ngOnInit(): void {
    this.breadcrumbsService.breadcrumbs.pipe(
      untilDestroyed(this)
    ).subscribe(menuItems => {
      this.initRoute(menuItems);
    })
    this.initRoute(this.breadcrumbsService.breadcrumbsSnapshot);

    this.store.select(organizationInfoSelector)
      .pipe(
        untilDestroyed(this)
      )
      .subscribe(organization => {
        if (organization) {
          this.showAuthButtons = !organization.isQRMenu;
          if (
            organization && organization.styles
            && !!organization.styles.logo && this.imgReg.test(organization.styles.logo)
          ) {
            this.logoImgSrc = organization.styles.logo;
          }
        }

      });
  }

  initRoute(menuItems: MenuItem[]) {
    this.rootRoute = menuItems[0].activatedRoute;
    let activeMenuItem = menuItems[menuItems.length - 1];
    this.showCloseButton =
      this.window.parent !== this.window && // если запустились в iframe
      menuItems.length === 1; // кнопку назад ненужно показывать только если мы на корневой странице

    if (menuItems.length > 1) {
      this.backRoute = menuItems[menuItems.length - activeMenuItem.backLevel - 1].activatedRoute;
    } else {
      this.backRoute = null;
    }
  }

  goProfile() {
    this.store.select('user')
      .pipe(
        take(1)
      )
      .subscribe(userState => {
        this.store.dispatch(successAuthBackPage(profilePath));
        let profileUrl: string[];

        if (userState.isAuthorized) {
          profileUrl = [profilePath];
        } else if (userState.isCodeSent) {
          profileUrl = [authPath, confirmPath];
        } else {
          profileUrl = [authPath];
        }
        this.router.navigate([...profileUrl], {relativeTo: this.rootRoute});
      }).unsubscribe();
  }
}
